<template>
  <b-modal
    id="popup"
    dialog-class="popup-wrap popup-wrap--youtube"
    centered
    hide-backdrop
    content-class="shadow"
    no-close-on-backdrop
    hide-header
    size="xl"
  >
    <div class="youtube--wrap">
      <iframe
        class="youtube-size"
        :src="videoUrl"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
    <template #modal-footer="{ hide }">
      <b-button size="lg" @click="hide()"> 닫기 </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'Popup',
  props: {
    videoId: {
      type: String,
      default: '',
    },
  },
  computed: {
    videoUrl() {
      return `https://www.youtube.com/embed/${this.videoId}?modestbranding=1&rel=0`;
    },
  },
  methods: {
    hideForOneDay() {
      this.$cookies.set('hidePopup', true);
      this.$bvModal.hide('popup');
    },
  },
};
</script>
